import { useEffect, useState } from 'react';
import { ThemeMode } from '../types';
import { getSettings, updateSettings } from '../db/settingsRepo';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../db/database';

export function useTheme() {
  const settings = useLiveQuery(() => db.settings.get('global_settings'));
  const [activeTheme, setActiveTheme] = useState<ThemeMode>('dark');

  const currentThemeMode: ThemeMode = settings?.theme || 'dark';

  useEffect(() => {
    const root = document.documentElement;
    let effectiveTheme: 'dark' | 'light' = 'dark';

    if (currentThemeMode === 'system') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      effectiveTheme = prefersDark ? 'dark' : 'light';
    } else {
      effectiveTheme = currentThemeMode;
    }

    if (effectiveTheme === 'dark') {
      root.classList.add('dark');
      root.classList.remove('light');
    } else {
      root.classList.remove('dark');
      root.classList.add('light');
    }

    setActiveTheme(currentThemeMode);
  }, [currentThemeMode]);

  const setTheme = async (mode: ThemeMode) => {
    await updateSettings({ theme: mode });
  };

  const toggleTheme = async () => {
    const nextMode: ThemeMode = currentThemeMode === 'dark' ? 'light' : 'dark';
    await setTheme(nextMode);
  };

  return {
    theme: currentThemeMode,
    isDark: document.documentElement.classList.contains('dark'),
    setTheme,
    toggleTheme,
  };
}
